// extracted by mini-css-extract-plugin
module.exports = {"item":"ButtonsBar_item__ySIUG","label":"ButtonsBar_label__B6XQ7"};